<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.text_171')"
    icon="bill-resource"
    :res-name="detailData.resource_name"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :getParams="getParams"
      :on-manager="onManager"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import BillShared from '../components/BillSharedList'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'ResourceBillSharedSidePage',
  components: {
    BillShared,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.bill_shared_details'), key: 'bill-shared' },
      ],
    }
  },
  computed: {
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'bill-shared':
          return 'OverviewForCloudDomainSidePage'
        case 'projects':
          return 'ProjectListForCloudDomainSidePage'
        default:
          return ''
      }
    },
    getParams () {
      return {
        resource_id: this.listRowData.resource_id,
        usage_type: this.listRowData.usage_type,
      }
    },
  },
}
</script>
